<template>
    <div class="loaderContainer">
        <div v-if="!p_showLoader_b" class="slot">
            <slot ></slot>
        </div>

        <div v-if="p_showLoader_b" class="TQ_verticalAlignMiddle">
            <ball-pulse-loader color="#2E294E" :size="p_ballSize_s"></ball-pulse-loader>
        </div>

        <!-- <div v-if="p_showLoader_b && p_tqLoader_b" class="TQ_direction_ltr" :class="p_absoluteCenter_b ? 'TQ_centerAbsolute' : ''">
            <SiLogoLoading width="150px"/>
            <div class="TqAppendMovingDots TQ_font_SecularOne">Loading</div>
        </div> -->

    </div>
</template>

<script>
    import Si_Logo from "../a_smartIcons/si_Logo";
    import SiLogoLoading from "../a_smartIcons/SiLogoLoading";
    import {BallPulseLoader} from 'vue-loaders'

    export default {
        name: "TqLoaderContainer",
        components: {SiLogoLoading, Si_Logo, BallPulseLoader},
        props: {
            p_showLoader_b:{
                require: true,
                type: Boolean
            },
            p_tqLoader_b:{
                type: Boolean,
                default: false
            },
            p_absoluteCenter_b:{
                type: Boolean,
                default: false
            },
            p_ballSize_s:{
                type: String,
                default: "10px"
            }
        }
    }
</script>

<style scoped lang="scss">
    .loaderContainer{
        height: inherit;
        overflow: hidden;

        .slot{
            height: inherit;
        }

    }
</style>